import styled from 'styled-components';
import {primaryColorLight} from '../../../config/colors';

export const ScoringTotalsWrapper = styled.div`
    display: flex;
    align-self: end;
    margin-top: -138px;
    max-width: 60%;
}
`;

export const ScoringTotalsTable = styled.table.attrs({
    cellSpacing: 0
})`
    & td, th {
        border: 1px solid white;
    }
    background-color: ${primaryColorLight};
    font-size: 14px;
`;

export const ScoringTotalsRow = styled.tr`
    
`;

export const ScoringTotalsCell = styled.td`
    text-align:right;
    padding: 0.5em;
`;

export const ScoringTotalsCellDouble = styled.td.attrs({
    colSpan: 2
})`
    white-space:nowrap;
    padding: 0.5em;
`;

export const ScoringTotalsColHeader = styled.th`
    > div {
        transform: rotate(0.75turn)
    }
    font-weight: normal;
`;

export const ScoringTotalsHeaderRow = styled.tr`
    height: 150px;
`;
